<template>
<section v-if="init">
    <rb-select
        label-position="left"
        :label="mainLabel"
        :options="options"
        v-model:value="walletOptions" />

    <div class="mt-4 text-left" :class="classBlock">
        <template v-if="walletOptions === 'select'">
            <!-- <rb-select
                render="depo"
                popoverType="warning"
                :help="depoInfo"
                :label="selectLabel"
                :options="selectOptions"
                :value="modelValue !== -1 ? modelValue : null"
                @update:value="$emit('update:modelValue', $event)" /> -->

            <rb-wallet-select
                :label="selectLabel"
                :items="selectOptions"
                :disabled="!selectOptions.length"
                :value="modelValue !== -1 ? modelValue : null"
                :helpers="walletSelectHelpers"
                @update:value="$emit('update:modelValue', $event)"/>
            
            <div v-if="!selectOptions.length" class="w-full mt-1 text-yellow-600 text-right text-[10px]">
                {{ quickStart.localization?.not_available_wallets_warning || 'Нет доступных кошельков, создайте новый' }}
            </div>
            <slot name="messages"></slot>
            
            <div v-if="symbolBalance || symbolTotalBalance" class="w-full flex justify-between mt-6">
                <n-statistic v-if="symbolBalance" :label="symbolBalanceLabel" tabular-nums>
                    <n-number-animation
                        :from="0"
                        :to="+symbolBalance"
                        :precision="8"
                    />
                </n-statistic>
                <n-statistic v-if="symbolTotalBalance" :label="symbolTotalBalanceLabel" tabular-nums>
                    <n-number-animation
                        :from="0"
                        :to="+symbolTotalBalance"
                        :precision="8"
                    />
                </n-statistic>
            </div>
            <div class="mt-4 flex justify-end">
                <n-button
                    strong
                    class="rounded-md text-white/90"
                    :color="gl.mainColor"
                    :disabled="!isWalletSelected || checkBalanceLoading"
                    :loading="checkBalanceLoading"
                    @click="onCheckBalance">
                    {{ buttonCheckLabel }}
                </n-button>
            </div>
        </template>
        <template v-else>
            <div
                v-for="(field, key) in walletModel"
                :key="key"
                class="flex items-end">
                <rb-input
                    class="mb-4"
                    :status="field.status === 'error' ? 'error' : undefined"
                    :msg="field.msg"
                    :label="field.title"
                    :placeholder="field.placeholder"
                    v-model:value="field.value"
                    @update:value="field.status = null, field.msg = null" />
                <div v-if="coinSymbolForWallet && key === 'amount'" class="flex items-center ml-4 mb-4">
                    <rb-coin class="w-6" :coin="currency(coinSymbolForWallet)" />
                    <span class="text-sm text-gray-600 dark:text-white/75 font-semibold uppercase ml-2 whitespace-nowrap">{{ coinSymbolForWallet }}</span>
                </div>
            </div>
            

            <div class="flex flex-wrap justify-end mt-4">
                <n-button
                    strong
                    class="rounded-md text-white/90"
                    :color="gl.mainColor"
                    :loading="loadingCreateWallet"
                    :disabled="createDiabled || loadingCreateWallet"
                    @click="onCreateWallet">
                    + {{ buttonCreateLabel }}
                </n-button>
            </div>
        </template>
    </div>
    <slot name="alerts"></slot>
</section>
</template>

<script>
// general
import general from './general';

// naive-ui
import {
    NIcon,
    NInput,
    NAlert,
    NSelect,
    NButton,
    NPopover,
    NStatistic,
    NRadioGroup,
    NRadioButton,
    NNumberAnimation } from 'naive-ui';

// icons
import { Warning24Filled, QuestionCircle20Filled } from '@vicons/fluent';

// components
import RbCoin from '@components/rb-coin';
import RbInput from '@components/rb-input/mobile.vue';
import RbSelect from '@components/rb-select/mobile.vue';
import RbWalletSelect from '@components/rb-wallet-select/mobile.vue';

export default {
    name: 'RbAlgoSelect',
    emits: ['update:modelValue'],
    props: {
        name: String,
        modelValue: String,
        loading: Boolean,
        buttonCheckLabel: String,
        buttonCreateLabel: String,
        symbolBalanceLabel: String,
        symbolTotalBalanceLabel: String,
        classBlock: String,
        depoInfo: String,
        mainData: {
            type: Object,
            required: true,
        },
        apiKey: {
            type: [String, Number],
            required: true,
        },
        selectLabel: {
            type: String,
            required: true,
        },
        mainLabel: {
            type: String,
            required: true,
        },
        alertLabel: {
            type: String,
        },
        tabOptionsRef: {
            type: Array,
            required: true,
        },
        selectOptionsRef: {
            type: [Array, Object],
            required: true,
        },
        walletModelInfo: {
            type: Array,
            required: true,
        },
        coinSymbolForWallet: {
            required: true,
        },
    },
    components: {
        NIcon,
        NInput,
        RbCoin,
        NAlert,
        NSelect,
        NButton,
        RbInput,
        RbSelect,
        NPopover,
        NStatistic,
        NRadioGroup,
        NRadioButton,
        RbWalletSelect,
        Warning24Filled,
        NNumberAnimation,
        QuestionCircle20Filled,
    },
    setup(props, context) {
        
        return {
            ...general(props, context),
        };
    },
};
</script>

<style lang="scss" scoped>
:deep(.n-statistic) {
  .n-statistic-value .n-statistic-value__content {
    font-size: 18px !important;
  }
}
</style>